import React from 'react'
import { useNavigate } from 'react-router-dom'

export default function Login() {
    const navigate = useNavigate();
    const handleLogin = () => {
      navigate('/dashboard');
    }
    
    return (
        <div>
            <div className="auth-page">
                <div className="container-fluid p-0">
                    <div className="row g-0">
                        <div className="col-xxl-3 col-lg-4 col-md-5">
                            <div className="auth-full-page-content d-flex p-sm-5 p-4">
                                <div className="w-100">
                                    <div className="d-flex flex-column h-100">
                                        <div className="mb-4 mb-md-5 text-center">
                                            <a href="#/" className="d-block auth-logo">
                                                <img src="assets/images/Olectra.svg"height={42} alt="logo" /> 
                                                {/* <span className="logo-txt">OLECTRA</span> */}
                                            </a>
                                        </div>
                                        <div className="auth-content my-auto">
                                            <div className="text-center">
                                                <h5 className="mb-0">Welcome Back !</h5>
                                                <p className="text-muted mt-2">Sign in to continue to Olectra.</p>
                                            </div>
                                            <form className="mt-4 pt-2">
                                                <div className="form-floating form-floating-custom mb-4">
                                                    <input type="text" className="form-control" id="input-username" placeholder="Enter User Name" />
                                                    <label htmlFor="input-username">Username</label>
                                                    <div className="form-floating-icon">
                                                        <i data-feather="users" />
                                                    </div>
                                                </div>
                                                <div className="form-floating form-floating-custom mb-4 auth-pass-inputgroup">
                                                    <input type="password" className="form-control pe-5" id="password-input" placeholder="Enter Password" />
                                                    <button type="button" className="btn btn-link position-absolute h-100 end-0 top-0" id="password-addon">
                                                        <i className="mdi mdi-eye-outline font-size-18 text-muted" />
                                                    </button>
                                                    <label htmlFor="input-password">Password</label>
                                                    <div className="form-floating-icon">
                                                        <i data-feather="lock" />
                                                    </div>
                                                </div>
                                                <div className="row mb-4">
                                                    <div className="col">
                                                        <div className="form-check font-size-15">
                                                            <input className="form-check-input" type="checkbox" id="remember-check" />
                                                            <label className="form-check-label font-size-13" htmlFor="remember-check">
                                                                Remember me
                                                            </label>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="mb-3">
                                                    <button className="btn btn-primary w-100 waves-effect waves-light" type="submit" onClick={handleLogin}>Log In</button>
                                                </div>
                                            </form>
                                           
                                           
                                        </div>
                                        <div className="mt-4 mt-md-5 text-center">
                                            <p className="mb-0">©  2025   . Designed   by Trans Global Geomatics Pvt Ltd</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {/* end auth full page content */}
                        </div>
                        {/* end col */}
                        <div class="col-xxl-9 col-lg-8 col-md-7">
                        <div class="auth-bg pt-md-5 p-4 d-flex">
                            {/* <div class="bg-overlay"></div> */}
                            
                            
                        </div>
                    </div>
                        {/* end col */}
                    </div>
                    {/* end row */}
                </div>
                {/* end container fluid */}
            </div>

        </div>
    )
}
